import { BaseError } from '~/assets/javascript/utils';

function getActionName(actionClassInstance) {
  try {
    return actionClassInstance.name;
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    return actionClassInstance.constructor.name;
  }
}

export class BaseMemberActionError extends BaseError {
  constructor(actionClassInstance, message) {
    super(`Error in Member Action "${getActionName(actionClassInstance)}": ${message}`);

    this.timestamp = new Date();
  }
}
